import { EnumCompanyStatus } from "@/shared/api-contract/api-contract";
import { useI18n } from "@/shared/composables/use-i18n";
import { currentUserModel } from "@/shared/state/current-user.model";
import { setup, Vue } from "vue-class-component";
import { appCompanyStatusDialogModel } from "./app-company-status-dialog.model";
import { sessionModel } from "@/shared/state/session.model";
import { currentCompanyModel } from "@/shared/state/current-company.model";

export class AppCompanyStatusDialogComponent extends Vue {
    model = setup(() => appCompanyStatusDialogModel);
    currentUser = setup(() => currentUserModel);
    currentCompany = setup(() => currentCompanyModel);
    sessionModel = setup(() => sessionModel);
    enumCompanyRole = EnumCompanyStatus;
    i18n = setup(useI18n);

    toggle(value: boolean) {
        if (value) {
            appCompanyStatusDialogModel.showCompanyStatusModal.value = "welcome";
        } else {
            appCompanyStatusDialogModel.showCompanyStatusModal.value = false;
        }
    }
}
